import {
  BaseBufferedRowViewTypeMixin,
  ViewType,
} from "@baserow/modules/database/viewTypes";
import { maxPossibleOrderValue } from "@baserow/modules/database/utils/view";

import CalendarView from "@peninsula/components/CalendarView";
import CalendarViewHeader from "@peninsula/components/CalendarViewHeader";

export class PeninsulaCalendarViewType extends BaseBufferedRowViewTypeMixin(
  ViewType,
) {
  static getType() {
    return "peninsula_calendar";
  }

  getIconClass() {
    return "iconoir-calendar";
  }

  getColorClass() {
    return "color-primary";
  }

  getName() {
    return "Calendar";
  }

  getHeaderComponent() {
    return CalendarViewHeader;
  }

  getHeaderClassNames() {
    return "header--dark-border";
  }

  getComponent() {
    return CalendarView;
  }

  canShowRowModal() {
    return true;
  }

  canSort() {
    return false;
  }

  canFetch(context, database, view) {
    return view.start_date_field !== null;
  }

  getDefaultFieldOptionValues() {
    return { hidden: false, order: maxPossibleOrderValue };
  }

  updated(context, view, oldView) {
    return (
      view.start_date_field !== oldView.start_date_field ||
      view.end_date_field !== oldView.end_date_field ||
      view.color_field !== oldView.color_field
    );
  }

  async afterFieldUpdated({ dispatch, rootGetters }, field, oldField) {
    if (oldField.type === "date" && field.type !== "date") {
      this._setFieldToNull(
        { dispatch, rootGetters },
        field,
        "start_date_field",
      );
      this._setFieldToNull({ dispatch, rootGetters }, field, "end_date_field");
    }
    if (oldField.type === "single_select" && field.type !== "single_select") {
      this._setFieldToNull({ dispatch, rootGetters }, field, "color_field");
    }
  }
}
